export const SET_STUDENTS = 'SET_STUDENTS';
export const SET_USERS = 'SET_USERS';
export const SET_ROLES = 'SET_ROLES';
export const EDIT_USER = 'EDIT_USER';
export const DELETE_USER = 'DELETE_USER';
